import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { BiEdit } from "react-icons/bi";
import { AiFillDelete } from "react-icons/ai";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteAFeature,
  getFeatures,
  resetState,
} from "../features/feature/featureSlice";
import CustomModal from "../components/CustomModal";

const columns = [
  {
    title: "SNo",
    dataIndex: "key",
  },
  {
    title: "Name",
    dataIndex: "name",
    sorter: (a, b) => a.name.length - b.name.length,
  },
  {
    title: "Action",
    dataIndex: "action",
  },
];

const FeatureList = () => {
  const [open, setOpen] = useState(false);
  const [featureId, setFeatureId] = useState("");
  const showModal = (e) => {
    setOpen(true);
    setFeatureId(e);
  };

  const hideModal = () => {
    setOpen(false);
  };
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(resetState());
    dispatch(getFeatures());
  }, []);
  const featureState = useSelector((state) => state.feature.features);
  const data1 = [];
  for (let i = 0; i < featureState.length; i++) {
    data1.push({
      key: i + 1,
      name: featureState[i].title,
      action: (
        <>
          <Link
            to={`/admin/feature/${featureState[i]._id}`}
            className=" fs-3 text-danger"
          >
            <BiEdit />
          </Link>
          
          <button
            className="ms-3 fs-3 text-danger bg-transparent border-0"
            onClick={() => showModal(featureState[i]._id)}
          >
            <AiFillDelete />
          </button>
        </>
      ),
    });
  }
  const deleteFeature = (e) => {
    dispatch(deleteAFeature(e));

    setOpen(false);
    setTimeout(() => {
      dispatch(getFeatures());
    }, 100);
  };
  return (
    <div>
      <h3 className="mb-4 title">Features</h3>
      <div>
        <Table columns={columns} dataSource={data1} />
      </div>
      <CustomModal
        hideModal={hideModal}
        open={open}
        performAction={() => {
          deleteFeature(featureId);
        }}
        title="Are you sure you want to delete this feature?"
      />
    </div>
  );
};

export default FeatureList;
